import { ADD_FAMILY,SET_INGREDIENTS, ADD_FAMILY_SUCCESS, ADD_INGREDIENT, GET_FAMILIES, INGREDIENTS_ERROR } from '../ActionTypes/IngredientVTypes';

const initialState = {
  families: [],
  ingredients: [], // Un objet où chaque famille est une clé
  loading: true,
  error: null,
};

const IngredientVReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_FAMILY:
      return {
        ...state,
        families: [...state.families, { name: action.payload.name, ingredients: [] }],
        ingredients: {
          ...state.ingredients,
          [action.payload.name]: [],
        },
        loading: false,
      };

    case ADD_FAMILY_SUCCESS:
      return {
        ...state,
        families: [...state.families, { name: action.payload.name, ingredients: action.payload.ingredients || [] }],
      };

     case GET_FAMILIES:
      return {
        ...state,
        families: action.payload, // 👈 charge bien les familles
        loading: false,
      };

    case INGREDIENTS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case ADD_INGREDIENT:
      const familyIngredients = state.ingredients[action.payload.familyName] || [];
      return {
        ...state,
        ingredients: {
          ...state.ingredients,
          [action.payload.familyName]: [...familyIngredients, action.payload.ingredientName],
        },
        loading: false,
      };

      case SET_INGREDIENTS:
        
      return {
        ...state,
        ingredients: action.payload,  // Mettez à jour l'état avec les ingrédients reçus
      };
      case 'UPDATE_STOCK_ALERT':
      return {
        ...state,
        ingredients: state.ingredients.map((ingredient) =>
          ingredient._id === action.payload._id ? action.payload : ingredient
        ),
      };
    case INGREDIENTS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default IngredientVReducer;
